import { render } from "./TooltipContent.vue?vue&type=template&id=f86aa1b6"
import script from "./TooltipContent.vue?vue&type=script&lang=js"
export * from "./TooltipContent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TooltipContent.vue"]])

export default __exports__